export default __webpack_public_path__ + "static/media/chevron.a9981b72.svg";